export const getDefaultOGImages = name => [
    {
        name,
        url: 'https://www.horsedeal.com/static/icons/android-chrome-512x512.png',
        width: 400,
        height: 400,
    },
];

export const listingImages = (name, mainListingImage) => {
    if (!mainListingImage) {
        return getDefaultOGImages(name);
    }
    return [
        {
            name,
            url: mainListingImage,
            width: 400,
            height: 400,
        },
    ];
};

export const noIndexTag = [
    {
        name: 'robots',
        content: 'noindex',
    },
];
